const getImagesPosition = (index: number, length: number) => {
  if (length === 1) {
    return 'col-span-4 row-span-2';
  }
  if (length === 2) {
    return 'col-span-2 row-span-2';
  }
  if (length === 3) {
    return index === 0 ? 'col-span-2 row-span-2' : 'col-span-2 row-span-1';
  }
  if (length === 4) {
    return index === 0
      ? 'col-span-2 row-span-2'
      : index < 3
      ? 'col-span-1 row-span-1'
      : 'col-span-2 row-span-1';
  }
  if (length === 5) {
    return index === 0 ? 'col-span-2 row-span-2' : 'col-span-1 row-span-1';
  }

  return '';
};

export const apartmentsConfig = {
  getImagesPosition,
};